// Mirrors the backend's own constraints exactly (files.controller.ts's
// ALLOWED_DOCUMENT_MIME / MAX_DOCUMENT_BYTES) so a rejected file is caught
// client-side, before a wasted round trip - the server still re-validates
// everything, this is purely a faster/friendlier first check.

export const PRACTICE_DOCUMENT_ACCEPTED_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
] as const;

export const PRACTICE_DOCUMENT_ACCEPT = PRACTICE_DOCUMENT_ACCEPTED_MIME_TYPES.join(',');

export const MAX_PRACTICE_DOCUMENT_BYTES = 25 * 1024 * 1024;

export const MAX_PRACTICE_DOCUMENT_DESCRIPTION_LENGTH = 500;

export function practiceDocumentValidationError(file: File): string | null {
    if (!(PRACTICE_DOCUMENT_ACCEPTED_MIME_TYPES as readonly string[]).includes(file.type)) {
        return 'Only PDF, JPEG, PNG, WEBP, DOC, or DOCX files are allowed.';
    }
    if (file.size > MAX_PRACTICE_DOCUMENT_BYTES) {
        return 'File exceeds the 25MB size limit.';
    }
    return null;
}
